{
  "contentFiltering": {
    "errors": {
      "conentBlock": "Au moins un texte est requis",
      "ecoScoreDataSource": "Au moins une source est requise",
      "ecoScoreDisplayMode": "Le mode d'affichage du eco-score est requis",
      "primaryProductAttributes": "Au moins une caractéristique principale est requise",
      "standardsToShow": "Au moins un standard est requis"
    }
  },
  "design": {
    "error": {
      "configurationsNotFound": "Une erreur (paramètres de personnalisation introuvables) est survenue lors du chargement des paramètres. Veuillez réessayer plus tard ou contacter support@traceforgood.com.",
      "generic": "Une erreur inattendue est survenue lors du chargement des paramètres. Veuillez réessayer plus tard ou contacter support@traceforgood.com.",
      "stylingParametersNotFound": "Une erreur (paramètres de personnalisation introuvables) est survenue lors du chargement des paramètres. Veuillez réessayer plus tard ou contacter support@traceforgood.com.",
      "title": "Erreur"
    },
    "noProductSheetGroup": {
      "message": "Veuillez contacter support@traceforgood.com pour activer les fonctionnalités du studio de communication.",
      "title": "Passer à l'offre supérieure"
    },
    "update": {
      "error": {
        "message": "Une erreur inattendue est survenue lors de la mise à jour.",
        "title": "Erreur"
      },
      "success": {
        "message": "Vos modifications sont enregistrées et seront visibles sur votre site e-commerce dans un délai de six heures.",
        "title": "Félicitations !"
      }
    }
  },
  "lockedFeatureOverlay": {
    "contentFiltering": {
      "buttonText": "Demander une démo",
      "message": "Prenez le contrôle et enrichissez le contenu publié dans les passeports des produits.",
      "title": "Passer à l'offre supérieure"
    },
    "designStudio": {
      "buttonText": "Demander une démo",
      "message": "Aligner le graphisme des passeports de vos produits avec votre charte interne pour garantir une narration omnicanale cohérente à vos clients.",
      "title": "Passer à l'offre supérieure"
    },
    "languages": {
      "buttonText": "Demander une démo",
      "message": "Activer des langues supplémentaires pour les passeports de vos produits.",
      "title": "Passer à l'offre supérieure"
    }
  },
  "logoDelete": {
    "error": {
      "message": "Une erreur inattendue est survenue lors de la suppression du logo.",
      "title": "Erreur"
    },
    "success": {
      "message": "Le logo a été supprimé avec succès",
      "title": "Félicitations !"
    }
  },
  "logoUpload": {
    "error": {
      "message": "Une erreur inattendue est survenue lors de la mise à jour de votre logo.",
      "title": "Erreur"
    }
  },
  "tabs": {
    "content": {
      "componentModal": {
        "componentTypeDisabledTooltip": "Ce bloc est déjà actif et ne peut pas être dupliqué.",
        "componentTypeLabel": "Type d'initiative",
        "componentTypeLockedTooltip": "Vous devez passer à l'offre supérieure pour débloquer ce composant.",
        "create": {
          "error": {
            "message": "Une erreur inattendue est survenue lors de la création de la rubrique {{componentType}}.",
            "title": "Erreur"
          },
          "success": {
            "message": "La rubrique {{componentType}} est maintenant active et sera visible dans les passeports des produits dans les 6 heures.",
            "title": "Félicitations !"
          },
          "title": "Partager une initiative"
        },
        "createButton": "Ajouter au passeport",
        "descriptions": {
          "LOGO": {
            "description": "Téléchargez votre logo pour l'afficher à côté des initiatives dans vos passeports produits. Vous pouvez ajuster les paramètres de design dans la section dédiée de l'onglet Design.",
            "helpText": "Glissez-déposez ou cliquez pour sélectionner un fichier image pour votre logo",
            "title": "Télécharger le logo"
          },
          "PRODUCT_ATTRIBUTES": {
            "description": "Choisissez les caractéristiques du produit à partager avec vos clients. Si deux informations distinctes partagent exactement la même valeur, celle-ci ne sera affichée qu'une seule fois. Vous pouvez distinguer les informations primaires des informations secondaires pour un affichage différencié.",
            "title": "Caractéristiques du produit"
          }
        },
        "ecoscore": {
          "cost": "Coût",
          "description": "Ce bloc affiche l'impact environnemental d'un produit dans son passeport. Le coût peut provenir du module Ecobalyse (s'il est actif) ou de votre catalogue de produits. Choisissez la source pour le coût et son taux de précision, que les règles Smart Display peuvent utiliser pour afficher le coût uniquement lorsqu'il atteint le niveau de précision requis.",
          "infoTitle": "Coût environnemental",
          "label": "Coût",
          "labelTooltip": "Sélectionnez la source du coût environnemental à afficher dans le passeport produit. Vous pouvez choisir le score Ecobalyse (si le module est actif) ou un attribut de coût environnemental importé dans votre catalogue produit.",
          "placeholder": "Sélectionnez une source",
          "title": "Attention",
          "warning": "L’affichage du coût environnemental requiert le dépôt préalable des justificatifs des produits sur la  <link1>plateforme</link1> de l’ADEME. Trace for good vous accompagne avec un export de données dédié, disponible <link2>ici</link2> (sélectionner l’export déclaration eco-score pour l’ADEME)."
        },
        "error": {
          "permissions": "Impossible de trouver les permissions des composants, veuillez rafraîchir la page"
        },
        "selectorPlaceholder": "Sélectionnez une initiative à partager",
        "update": {
          "button": "Mettre à jour",
          "error": {
            "message": "Une erreur inattendue est survenue lors de la mise à jour de la rubrique {{componentType}}.",
            "title": "Erreur"
          },
          "success": {
            "message": "La rubrique {{componentType}} est maintenant active et sera visible dans les passeports des produits dans les 6 heures.",
            "title": "Félicitations !"
          }
        }
      },
      "components": {
        "ACTIVITY_LIST": "Liste des opérations de production sans icônes",
        "BULLETED_LIST": "Liste avec des points",
        "DETAILED_PRODUCT_COMPOSITION": "Composition détaillée du produit",
        "ECOSCORE": "Coût environnemental",
        "GENERIC_PASSPORT_TITLE": "Le titre générique",
        "LOGO": "Logo de la marque",
        "ORGANIZATION_TITLE": "Le nom de la marque",
        "PACKAGING_INFO": "Informations sur l'emballage",
        "POWERED_BY": "Avec le soutien de",
        "PRODUCT_ATTRIBUTES": "Caractéristiques du produit",
        "PRODUCT_IMAGE": "Le visuel du produit",
        "RECYCLED_MATERIALS_INFO": "Informations sur les matières recyclées",
        "TEXT_HEADER": "Nouvelle rubrique (titre)",
        "TEXT_PARAGRAPH": "Nouvelle rubrique (paragraphe)",
        "TEXT_PARAGRAPH_V2": "Nouvelle rubrique",
        "TRIMAN_FOOTER": "Pied de page sans logo Trace for good"
      },
      "componentsEditor": {
        "createComponent": "Partager plus",
        "subtitle": "Liste des rubriques df'information actives et visibles dans les passeports des produits. Des règles et conditions dynamiques d’affichage peuvent s’appliquer et cacher une ou plusieurs rubriques pour un produit.",
        "title": "Initiatives & engagements RSE"
      },
      "contentFiltering": {
        "ecoScoreDisplayMode": {
          "label": "Audience cible",
          "placeholder": "Sélectionnez un mode d'affichage",
          "subtitle": "Configurez l'audience cible pour le coût environnemental dans le passeport du produit.",
          "title": "Coût environnemental",
          "tooltip": "L’audience cible fait référence aux destinataires prévus du contenu du passeport produit. Dans ce contexte, il précise si l'affichage du coût environnemental est destiné à un usage B2B (entreprise à entreprise) ou B2C (entreprise à consommateur). Cette distinction est importante : les affichages B2C doivent respecter des exigences réglementaires strictes et utiliser un format de macaron officiel, tandis que les affichages B2B nécessitent uniquement un texte brut indiquant la valeur du coût.",
          "update": {
            "error": {
              "message": "Le mode d'affichage du coût environnemental n'a pas été mis à jour.",
              "title": "Erreur"
            },
            "success": {
              "message": "Le mode d'affichage du coût environnemental a été mis à jour avec succès.",
              "title": "Mode d'affichage mis à jour"
            }
          }
        },
        "standardsConfiguration": {
          "update": {
            "error": {
              "message": "Les standards et certifications n'ont pas été mis à jour.",
              "title": "Erreur"
            },
            "success": {
              "message": "Les standards et certifications ont été mis à jour avec succès.",
              "title": "Standards et certifications mis à jour"
            }
          }
        },
        "standardsToShow": {
          "emptyMessage": "Aucun",
          "label": "Standards et certifications éligibles",
          "labelTooltip": "Sélectionnez les standards atteints et les certifications obtenues qui seront affichés dans le passeport du produit.",
          "placeholder": "Sélectionnez les standards et certifications éligibles",
          "subtitle": "Configurez l’affichage dynamique des standards et certifications obtenus par vos produits.",
          "title": "Standards et certifications"
        },
        "subtitle": "Les règles et conditions permettent de protéger votre image de marque et de garantir la fiabilité et la pertinence des informations présentées dans les différentes rubriques du passeport.",
        "title": "Affichage intelligent"
      },
      "editProductComponentModal": {
        "cancelButton": "Annuler",
        "error": {
          "message": "Une erreur inattendue est survenue lors de la mise à jour du contenu du composant.",
          "title": "Erreur"
        },
        "saveButton": "Sauvegarder",
        "success": {
          "message": "Contenu du composant mis à jour avec succès",
          "title": "Félicitations !"
        }
      },
      "header": {
        "subtitle": "Partagez les bonnes informations, au bon moment, pour une communication fidèle, fiable et alignée avec vos engagements RSE et votre image de marque.",
        "title": "Contenu du passeport"
      },
      "label": "Contenu",
      "logoModal": {
        "changeLogo": "Changer le logo",
        "removeLogo": "Supprimer le logo"
      },
      "productAttributes": {
        "options": {
          "brand": "Marque",
          "brandReference": "Référence",
          "collection": "Collection",
          "color": "Couleur",
          "name": "Nom",
          "purchaseOrderReference": "Commande"
        },
        "primary": {
          "emptyMessage": "Aucune caractéristique principale sélectionnée",
          "label": "Caractéristiques principales",
          "labelTooltip": "Sélectionnez les caractéristiques du produit qui seront affichées dans le passeport du produit.",
          "placeholder": "Sélectionnez les caractéristiques principales"
        },
        "primaryProductAttributes": {
          "error": {
            "too_small": "Au moins une caractéristique principale doit être sélectionnée"
          }
        },
        "secondary": {
          "emptyMessage": "Aucune caractéristique secondaire sélectionnée",
          "label": "Caractéristiques secondaires",
          "labelTooltip": "Sélectionnez les caractéristiques du produit qui seront affichées dans le passeport du produit.",
          "placeholder": "Sélectionnez les caractéristiques secondaires"
        },
        "secondaryProductAttributes": {
          "error": {
            "too_small": "Au moins une caractéristique secondaire doit être sélectionnée"
          }
        }
      },
      "tooltip": "Partager vos engagements sereinement avec un contenu choisi et sécurisé qui valorise vos produits et vos initiatives RSE auprès de vos clients.",
      "updateProductPageComponents": {
        "deleteComponent": {
          "areYouSureText": "Voulez-vous vraiment supprimer ce module, toutes les traductions et contenus seront perdus",
          "cancelText": "Annuler",
          "confirmText": "Supprimer",
          "error": {
            "message": "Erreur lors de la suppression du module",
            "title": "Erreur"
          },
          "success": {
            "message": "Module supprimé",
            "title": "Supprimé"
          }
        },
        "success": {
          "message": "Vos modifications sont enregistrées et seront visibles sur votre site e-commerce dans un délai de six heures.",
          "title": "Félicitations !"
        }
      }
    },
    "design": {
      "categories": {
        "activities": "La section Traçabilité",
        "detailedProductComposition": "La section composition",
        "ecoscore": "La section Affichage environnemental (eco-score)",
        "footer": "Le pied de page",
        "genericPassportTitle": "Le titre générique",
        "global": "Les corps de page",
        "logo": "Logo de la marque",
        "mainHeader": "La section Produit",
        "organizationTitle": "Le nom de la marque",
        "packagingInfo": "La section Autres qualités et caractéristiques environnementales",
        "productAttributes": "Caractéristiques du produit",
        "productImage": "Image du produit",
        "searchEngine": "Le moteur de recherche"
      },
      "enums": {
        "align": {
          "center": "Centré",
          "end": "Fin",
          "left": "Gauche",
          "right": "Droite",
          "start": "Début"
        },
        "flexAlign": {
          "flexEnd": "Fin",
          "flexStart": "Début"
        },
        "textDecoration": {
          "lineThrough": "Barré",
          "overline": "Surligné",
          "underline": "Souligné"
        },
        "textTransform": {
          "capitalize": "Majuscules",
          "lowercase": "Minuscules",
          "none": "Aucun",
          "uppercase": "Majuscules"
        }
      },
      "header": {
        "subtitle": "Assurez à vos clients une expérience visuelle omnicanale cohérente avec un design des passeports de vos produits, et du moteur de recherche associé, fidèle à votre charte graphique et votre image de marque.",
        "title": "Apparence du passeport & du moteur de recherche"
      },
      "label": "Design",
      "style": {
        "activities": {
          "activitiesDepth": "Afficher ... étapes",
          "activity": {
            "props": {
              "fontSize": "Etape (taille)",
              "fontWeight": "Etape (épaisseur)",
              "letterSpacing": "Etape (distance entre les lettres)",
              "lineHeight": "Interligne",
              "textTransform": "Etape (casse d'écriture)"
            }
          },
          "country": {
            "props": {
              "fontSize": "Pays (taille)",
              "fontWeight": "Pays (épaisseur)",
              "letterSpacing": "Pays (distance entre les lettres)",
              "textTransform": "Pays (casse d'écriture)"
            }
          },
          "showActivityIcons": "Afficher les icônes",
          "showCertificates": "Afficher les certificats",
          "showCountryFlags": "Afficher les drapeaux"
        },
        "appHeader": {
          "backgroundColor": "Arrière-plan 2 (couleur)",
          "marginBottom": "Marge intermédiaire"
        },
        "backgroundColor": "Arrière-plan 1 (couleur)",
        "contentBlocks": {
          "props": {
            "gap": "Sections (distance)"
          }
        },
        "contentVerticalSpacing": "Sections (distance titre/paragraph)",
        "detailedProductComposition": {
          "content": {
            "color": "Composant & Matériau (couleur)",
            "fontFamily": "Composant & Matériau (police de caractères)",
            "fontSize": "Composant & Matériau (taille)",
            "fontWeight": "Composant & Matériau (épaisseur)",
            "paddingBottom": "Composant & Matériau (espace en dessous)",
            "textAlign": "Composant & Matériau (alignement)",
            "textTransform": "Composant & Matériau (casse)"
          },
          "title": {
            "color": "Titre (couleur)",
            "fontFamily": "Titre (police de caractères)",
            "fontSize": "Titre (taille)",
            "fontWeight": "Titre (épaisseur)",
            "letterSpacing": "Titre (distance entre les lettres)",
            "lineHeight": "Titre (hauteur de ligne)",
            "paddingBottom": "Titre (espace en dessous)",
            "textAlign": "Titre (alignement)",
            "textDecoration": "Titre (decoration)",
            "textTransform": "Titre (casse)"
          }
        },
        "ecoscore": {
          "ecoscoreAlign": {
            "value": "Position du badge"
          },
          "ecoscoreB2b": {
            "fontSize": "Taille de la police",
            "fontWeight": "Épaisseur de la police",
            "textAlign": "Alignement du texte",
            "textTransform": "Casse de la police"
          }
        },
        "fontFamily": "Police de caractères",
        "footer": {
          "lastUpdate": {
            "fontSize": "Mise à jour (taille)",
            "fontWeight": "Mise à jour (épaisseur)"
          },
          "marginBottom": "Marge en dessous",
          "marginTop": "Marge au dessus",
          "showLastUpdateTimestamp": "Afficher la date de mise à jour",
          "showPoweredByTFG": "Afficher le logo Trace for good"
        },
        "genericPassportTitle": {
          "background": "Arrière-plan (couleur)",
          "color": "Titre (couleur)",
          "fontFamily": "Titre (police de caractères)",
          "fontSize": "Titre (taille)",
          "fontWeight": "Titre (épaisseur)",
          "letterSpacing": "Titre (distance entre les lettres)",
          "lineHeight": "Titre (hauteur de ligne)",
          "textAlign": "Titre (alignement)",
          "textDecoration": "Titre (décoration)",
          "textTransform": "Titre (casse)"
        },
        "headerFontFamily": "Titres (police de caractères)",
        "headerFontSize": "Titres (taille)",
        "headerFontWeight": "Titres (épaisseur)",
        "headerLineHeight": "Titres (hauteur de ligne)",
        "headerTextDecoration": "Titres (décoration)",
        "headerTextTransform": "Titres (casse)",
        "height": "Hauteur totale",
        "letterSpacing": "Distance entre les lettres",
        "lineHeight": "Hauteur des lignes",
        "logo": {
          "height": "Logo (hauteur)",
          "logoAlign": "Alignement du logo",
          "logoFile": "Fichier logo",
          "width": "Logo (largeur)"
        },
        "mainContainer": {
          "props": {
            "justifyContent": "Centrage du texte",
            "letterSpacing": "Distance entre les lettres",
            "textAlign": "Alignement du texte",
            "textTransform": "Casse d'écriture"
          }
        },
        "organizationTitle": {
          "backgroundColor": "Nom de la marque (arrière-plan)",
          "color": "Nom de la marque (couleur)",
          "fontFamily": "Nom de la marque (police de caractères)",
          "fontSize": "Nom de la marque (taille)",
          "fontWeight": "Nom de la marque (épaisseur)",
          "textAlign": "Nom de la marque (alignement)",
          "textTransform": "Nom de la marque (casse)"
        },
        "packagingInfo": {
          "marginBottom": "Marge en dessous",
          "packagingInfoHeader": {
            "fontWeight": "Titre (épaisseur)",
            "textTransform": "Titre (casse)"
          },
          "packagingInfoHyperLink": {
            "color": "Lien Scan4Chem (couleur)",
            "fontWeight": "Lien Scan4Chem (épaisseur)",
            "textDecoration": "Lien Scan4Chem (décoration)"
          },
          "recycledPackagingKeyInfo": {
            "fontWeight": "Informations clés (épaisseur)"
          }
        },
        "paddingBlock": "Sections (distance 2)",
        "paddingInline": {
          "value": "Espace vide"
        },
        "productAttributes": {
          "primaryInformation": {
            "color": "Primaire (couleur)",
            "fontFamily": "Primaire (police de caractères)",
            "fontSize": "Primaire (taille)",
            "fontWeight": "Primaire (épaisseur)",
            "textAlign": "Primaire (alignement)",
            "textTransform": "Primaire (casse)"
          },
          "productAttributesContainer": {
            "alignItems": "Alignement des éléments",
            "gap": "Espacement",
            "marginBottom": "Marge en dessous"
          },
          "secondaryInformation": {
            "color": "Secondaires (couleur)",
            "fontFamily": "Secondaires (police de caractères)",
            "fontSize": "Secondaires (taille)",
            "fontWeight": "Secondaires (épaisseur)",
            "textAlign": "Secondaires (alignement)",
            "textTransform": "Secondaires (casse)"
          }
        },
        "productImage": {
          "height": "Hauteur",
          "imageAlign": "Alignement de l'image",
          "width": "Largeur"
        },
        "searchEngine": {
          "backgroundColor": "Arrière-plan (couleur 1)",
          "fontFamily": "Police de caractères",
          "productCardBadgeBackgroundColor": {
            "value": "Badge collection (couleur 1)"
          },
          "productCardBadgeTextColor": {
            "value": "Badge collection (couleur 2)"
          },
          "searchEngineHeader": {
            "backgroundColor": "Arrière-plan (couleur 2)",
            "color": "Textes (couleur 1)"
          },
          "searchEngineTextColor": {
            "value": "Textes (couleur 2)"
          }
        },
        "textColor": {
          "value": "Paragraphe (couleur)"
        },
        "textFontSize": "Paragraphe (taille)",
        "textFontWeight": {
          "value": "Paragraphe (épaisseur)"
        },
        "titleColor": {
          "value": "Titres (couleur)"
        },
        "width": "Largeur"
      },
      "tooltip": "Aligner le graphisme des passeports de vos produits avec votre charte interne pour garantir une communication omnicanale cohérente à vos clients.",
      "tooltips": {
        "activitiesDepth": "Nombre maximum d'opération de production que vous souhaitez présenter à vos clients lorsqu'elles sont renseignées.",
        "showCertificates": "Les certifications affichées sont liées aux informations collectées."
      }
    },
    "general": {
      "communicationMaterials": {
        "productPassports": {
          "deactivated": "Les URLs et QR codes sont indisponibles. Contactez support@traceforgood.com pour activer votre plan de communication.",
          "message": "Pour chaque produit, l'URL et son QR code sont disponibles dans la page de détail du produit.",
          "title": "Passeports"
        },
        "searchEngine": {
          "deactivated": "indisponible",
          "mainURL": "URL du moteur de recherche",
          "printableQRCode": "QR code imprimable du moteur de recherche",
          "title": "Passeport produit et moteur de recherche"
        },
        "subtitle": "Liens d'accès et autres informations associés à vos supports de communication.",
        "title": "Supports de communication"
      },
      "label": "Général",
      "subscriptionPlanChangeSuccess": {
        "message": "Votre plan d'abonnement a été changé et vous pouvez désormais accéder aux nouvelles fonctionnalités.",
        "title": "Plan d'abonnement changé avec succès !"
      },
      "subscriptionPlanModal": {
        "areYouSureText": "Etes vous sûr de vouloir changer de plan d'abonnement pour {{name}} ?",
        "cancelText": "Annuler",
        "confirmText": "Confirmer",
        "title": "Changer de plan d'abonnement"
      },
      "subscriptionPlans": {
        "ADVANCED": {
          "description": "Enrichir vos passeports produits avec un visuel impactant et activer une troisième langue pour élargir votre portée internationale.",
          "name": "ADVANCED"
        },
        "EXPERT": {
          "description": "Accéder à l’ensemble des paramètres de personnalisation graphique pour aligner votre communication avec votre charte visuelle et offrir une expérience omnicanale sur-mesure à vos consommateurs.",
          "name": "EXPERT"
        },
        "NONE": {
          "name": "Aucun plan d'abonnement sélectionné"
        },
        "STARTER": {
          "description": "Activer le moteur de recherche et les passeports produits dans leur version standard et traduire leurs contenus dans deux langues, dont l’anglais.",
          "name": "STARTER"
        },
        "subtitle": "Contactez notre équipe à support@traceforgood.com pour planifier une démo et découvrir les fonctionnalités du plan supérieur.",
        "title": "Formules d'abonnement"
      },
      "tooltip": "Renforcer la visibilité de vos démarches de traçabilité grâce à un plan de communication sur mesure et des outils intelligents tels que le passeport produit, le moteur de recherche, les différents QR codes et les liens partageables."
    },
    "languages": {
      "activeLanguages": {
        "maxLanguagesSelectedReached": {
          "infoBox": {
            "message": "Vous avez sélectionné le maximum de languages possible que vous confère votre plan. Veuillez supprimer une langue ou contacter support@traceforgood.com pour passer au plan supérieur si vous souhaitez en ajouter une autre",
            "title": "Nombre maximum de langues atteint"
          }
        },
        "subtitle": "Communiquez avec votre cœur de cible dans sa langue et optimisez la portée internationale de vos supports de communication avec des traductions percutantes.",
        "title": "Langages actifs"
      },
      "label": "Langages",
      "tooltip": "Adresser votre cœur de cible et déployer la portée internationale de vos supports de communication avec des traductions de contenu dans différentes langues.",
      "translations": {
        "subtitle": "Gérez les traductions des contenus partagés (titres, paragraphes, etc.) dans les langages actifs pour assurer la cohérence internationale du message avec votre stratégie marketing et votre image de marque.",
        "title": "Traductions"
      }
    }
  },
  "title": "Studio de communication"
}
